'use client';

import { Box, Button, Flex, Icon, Image, Text } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { MdOutlineArrowBackIos, MdOutlineErrorOutline } from 'react-icons/md';

const ErrorState = ({
  reset,
  title = 'Ocorreu um erro',
  description = 'Não foi possível carregar esta página. Tenta novamente.',
}: {
  reset: () => void;
  title?: string;
  description?: string;
}) => {
  const router = useRouter();

  return (
    <Box
      minH="100vh"
      bg={{ base: '#F0F5F8', _dark: '#060F18' }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      px="20px"
      pos="relative"
      overflow="hidden"
    >
      <Box
        pos="absolute"
        top="-160px"
        right="-160px"
        w="520px"
        h="520px"
        borderRadius="full"
        pointerEvents="none"
        style={{
          background:
            'radial-gradient(circle, rgba(0,176,202,0.1) 0%, transparent 65%)',
        }}
      />
      <Box
        pos="absolute"
        bottom="-100px"
        left="-100px"
        w="420px"
        h="420px"
        borderRadius="full"
        pointerEvents="none"
        style={{
          background:
            'radial-gradient(circle, rgba(10,27,43,0.07) 0%, transparent 65%)',
        }}
      />

      <Flex
        flexDir="column"
        align="center"
        w="100%"
        maxW="440px"
        bg={{ base: '#FFFFFF', _dark: '#0A1B2B' }}
        borderRadius="28px"
        border="2px solid"
        borderColor={{ base: 'rgba(0,0,0,0.07)', _dark: 'rgba(255,255,255,0.06)' }}
        boxShadow={{
          base: '0 24px 64px rgba(0,0,0,0.10)',
          _dark: '0 24px 64px rgba(0,0,0,0.45)',
        }}
        overflow="hidden"
      >
        <Box
          w="100%"
          h="5px"
          flexShrink={0}
          style={{ background: 'linear-gradient(to right, #0A1B2B, #00B0CA)' }}
        />

        <Flex flexDir="column" align="center" gap="24px" p="40px 32px 36px">
          <Image
            src="/ido-logo.png"
            w="110px"
            cursor="pointer"
            onClick={() => router.push('/')}
          />

          <Flex
            w="76px"
            h="76px"
            borderRadius="22px"
            bg={{ base: 'rgba(0,176,202,0.06)', _dark: 'rgba(0,176,202,0.1)' }}
            border="2px solid"
            borderColor={{
              base: 'rgba(0,176,202,0.18)',
              _dark: 'rgba(0,176,202,0.22)',
            }}
            align="center"
            justify="center"
          >
            <Icon w="34px" h="34px" color="#00B0CA">
              <MdOutlineErrorOutline />
            </Icon>
          </Flex>

          <Flex flexDir="column" align="center" gap="10px" textAlign="center">
            <Text
              fontSize="19px"
              fontWeight="700"
              color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
              lineHeight="1.3"
            >
              {title}
            </Text>
            <Text
              fontSize="14px"
              lineHeight="1.65"
              color={{ base: 'rgba(0,0,0,0.5)', _dark: 'rgba(255,255,255,0.45)' }}
            >
              {description}
            </Text>
          </Flex>

          <Box
            w="100%"
            h="1px"
            bg={{ base: 'rgba(0,0,0,0.07)', _dark: 'rgba(255,255,255,0.06)' }}
          />

          <Flex w="100%" gap="10px">
            <Button
              flex="1"
              h="44px"
              variant="outline"
              borderColor={{ base: 'rgba(0,0,0,0.12)', _dark: 'rgba(255,255,255,0.14)' }}
              fontWeight="700"
              fontSize="14px"
              borderRadius="full"
              onClick={() => router.push('/')}
            >
              <Icon w="14px" h="14px" mr="8px">
                <MdOutlineArrowBackIos />
              </Icon>
              Início
            </Button>
            <Button
              flex="1"
              h="44px"
              bg="#00B0CA"
              color="#fff"
              fontWeight="700"
              fontSize="14px"
              borderRadius="full"
              boxShadow="0 4px 20px rgba(0,176,202,0.3)"
              transition="all 0.2s"
              _hover={{
                bg: '#009AB5',
                boxShadow: '0 6px 24px rgba(0,176,202,0.45)',
              }}
              _active={{ bg: '#0090AA', transform: 'scale(0.98)' }}
              onClick={reset}
            >
              Tentar novamente
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ErrorState;
